// This script is meant to hide certain modules on certain formats. Several
// imprints need a way to show content on one related format and not others
// without unlinking the related formats.
/* eslint-disable no-param-reassign */
function hideElement() {
  const element = document.querySelectorAll('.hide-all');
  if (element) {
    Array.prototype.forEach.call(
      element,
      (el) => {
        el.style.display = 'none';
        for (let i = 0; i < el.classList.length; i += 1) {
          if (el.classList[i].includes('show-this-')) {
            const show = el.classList[i].replace('show-this-', 'postid-');
            if (document.body.classList.contains(show)) {
              el.style.display = 'block';
            }
          }
        }
      }
    );
  }
}

window.load = hideElement();
